import CreneauDate from '@/generated/controls/creneau/CreneauDate.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: CreneauDate
})
